import { useState } from "react";
import { IDashCannedResponse, useCannedResponseSenderApi } from "@nkr/models/dash/dash-canned-response";
import { useForm } from '@nkr/utils/rest-api';
import { Well, FormControl, Button, Glyphicon, Row, Col } from "react-bootstrap";

interface IProps {
    registrationId: number,
}

export const FormSendCannedEmail = (props: IProps) => {
    const [selectedEmail, setSelectedEmail] = useState<IDashCannedResponse>({} as IDashCannedResponse);

    const api = useCannedResponseSenderApi(props.registrationId);
    const results = api.useGetAll();
    const form = useForm<IDashCannedResponse>(api, null, null, null, selectedEmail);

    return <>
        {!results.isSuccess && "Loading..."}

        {results.isSuccess && results?.payload && (
            <>
                <Row style={{ marginBottom: 10 }}>
                    <Col xs={12}><strong>Which Email Template?</strong></Col>
                    <Col xs={12}>
                        <FormControl componentClass="select" value={selectedEmail.id || ''} onChange={(e) => {
                            const value = (e.target as HTMLSelectElement).value;
                            const selected = results.payload?.find(r => r.id.toString() === value);
                            setSelectedEmail(selected || {} as IDashCannedResponse);
                            form.replaceData(selected || {} as IDashCannedResponse);
                        }}>
                            <option value=''>-- Select an email --</option>
                            {results.isSuccess && results?.payload && results.payload.map((item) => (
                                <option key={item.id} value={item.id}>{item.name}</option>
                            ))}
                        </FormControl>
                    </Col>
                </Row>

                <form onSubmit={form.handleSubmit}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col xs={12}><strong>Email Subject:</strong></Col>
                        <Col xs={12}><FormControl required name='emailSubject' type="text" placeholder="e.g. We were unable to contact you" value={form.data.emailSubject ?? ''} onChange={form.handleStringChange} /></Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col xs={12}><strong>Email Content:</strong></Col>
                        <Col xs={12}><FormControl required componentClass='textarea' name='emailContent' type="text" value={form.data.emailContent ?? ''} onChange={form.handleStringChange} style={{ height: 200 }} /></Col>
                    </Row>
                    <Row>
                        <Col xs={6}><Button bsStyle="primary" type='submit'>Send Email</Button></Col>
                    </Row>
                </form>
            </>
        )}
    </>;
};